import { apiHost } from './env.conf'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
// if (process.env.NODE_ENV !== 'production') {
//     axios.defaults.baseURL = '/'
// }
// 默认接口前缀
axios.defaults.baseURL = `${apiHost}/`

axios.defaults.withCredentials = true
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.interceptors.response.use(function (response) {
    // Do something before request is sent
    if (response.data && Number(response.data.status) === 0) {
        return response.data
    } else {
        return Promise.reject(response.data, response)
    }
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})
Vue.use(VueAxios, axios)



// WEBPACK FOOTER //
// ./src/config/api.conf.js